import './styles/app.css';

import { QueryClient, QueryClientProvider, requestDeals } from '@workspace/api';
import { Toaster } from '@workspace/ui/components/sonner';
import { ThemeProvider } from '@workspace/ui/components/theme-provider';
import { sentryInit } from '@workspace/utils';
import { setDefaultOptions } from 'date-fns';
import { fr } from 'date-fns/locale';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { toast } from 'sonner';
import App from './app';

setDefaultOptions({ locale: fr });

sentryInit();

// Configuration du client de requêtes
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnMount: false,
            refetchOnWindowFocus: true,
            staleTime: 60 * 60 * 1000, // 1 hour
            gcTime: 60 * 60 * 1000, // 1 hour
        },
    },
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <ThemeProvider
                    defaultTheme="light"
                    storageKey="deals-theme"
                >
                    <App />
                    <Toaster
                        position="top-center"
                        closeButton
                        expand={false}
                        duration={10000}
                    />
                </ThemeProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>,
);

// Intercepteur toast pour les réponses API (le 401 redirect est déjà géré dans @workspace/api)
requestDeals.interceptors.response.use(
    (response) => {
        const message = response?.data?.message || response?.data?.data?.message;
        if (message) {
            toast.success(message);
        }
        return response;
    },
    (error) => {
        if (error.response?.status === 401 || error.response?.status === 404) {
            return Promise.reject(error);
        }
        const message = error.response?.data?.message || error.message;
        if (message) {
            toast.error(message);
        }
        return Promise.reject(error);
    },
);
